import { IStarkeyContact } from '../../../models/constants';
import { IContactInfo } from '../../../models/pro-sites';
import * as CON from '../../common/constants';

const CONTACTS_DE: IStarkeyContact[] = [
    {
        title: 'Customer Service',
        telephone: '+49 40 429473 350',
        email: ['customer_service@starkey.de', 'bestellung@starkey.de'],
    },
    {
        title: 'Customer Service IDO Support',
        telephone: '+49 40 429473 380',
        email: ['ido-support@starkey.de'],
    },
    {
        title: 'Technischer Support',
        telephone: '+49 40 429473 370',
        email: ['techsupport@starkey.de'],
    },
    {
        title: 'Marketingberatung',
        name: 'Beate Stropahl',
        telephone: '+49 40 429473-111',
        email: ['marketing@starkey.de'],
    },
];

const CONTACTS_KR: IStarkeyContact[] = [
    {
        title: 'Technischer Support_KR',
        telephone: '+49 40 429473 370_KR',
        email: ['techsupport@starkey.de'],
    },
    {
        title: 'Marketingberatung_KR',
        name: 'Beate Stropahl_KR',
        telephone: '+49 40 429473-111',
        email: ['marketing@starkey.de'],
    },
];

//IStarkeyContact
export function getContacts(countryCode: string): IStarkeyContact[] {
    switch (countryCode) {
        case CON.DE:
            return CONTACTS_DE;
            break;
        default:
            return CONTACTS_DE;
            break;
    }
}
